import { useState, useRef } from 'react';
import { ChevronDown } from 'lucide-react';
import { DropdownItem, DropdownProps } from '@/types';
import { useClickOutside } from '@/hooks';
import { Link } from 'react-router-dom';

const Dropdown = ({ label, items, icon: Icon, className = "" }: DropdownProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useClickOutside(dropdownRef, () => setIsOpen(false));

  const handleItemClick = (item: DropdownItem): void => {
    setIsOpen(false);
    item.onClick?.();
  };

  return (
    <div className={`relative ${className} `} ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="cursor-pointer flex items-center space-x-2 px-4 py-2 text-white hover:bg-white/10 rounded-lg transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-white/20"
        aria-expanded={isOpen}
      >
        {Icon && <Icon size={18}/>}
        <span className="font-medium">{label}</span>
        <ChevronDown
          size={16}
          className={`transform transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
        />
      </button>
      {isOpen && (
        <div
          className="absolute top-full left-0 mt-2 w-60 bg-white dark:bg-gray-900 rounded-lg shadow-xl border border-gray-200 dark:border-gray-700 py-2 z-50 animate-in fade-in slide-in-from-top-2 duration-200">
          {items.map((item, index) => (
            <Link to={item.route || '#'}>
              <button
                key={index}
                onClick={() => handleItemClick(item)}
                className="cursor-pointer flex items-center w-full px-4 py-3 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors duration-150"
              >
                {item.icon && <item.icon size={16} className="mr-3 text-gray-500 dark:text-gray-400"/>}
                <span>{item.label}</span>
              </button>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default Dropdown;
